import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Star } from "lucide-react";
import menu from "../data/menu.json";
import { Ph } from "../lib/draft";
import { SectionTitle } from "./SectionTitle";
import { Reveal } from "./Reveal";

const ItemList = ({ category }) => (
    <ul className="divide-y divide-bordo">
        {category.items.map((item, i) => (
            <li key={item.name} className="py-4 flex items-baseline justify-between gap-6">
                <div>
                    <p className="font-medium">{item.name}</p>
                    {item.description ? (
                        <p className="text-sm text-avorio/60 mt-0.5">{item.description}</p>
                    ) : (
                        <p className="text-sm mt-0.5">
                            <Ph what={`descrizione di ${item.name}`} hide />
                        </p>
                    )}
                </div>
                <span className="tabular text-ambra font-medium shrink-0" data-testid={`menu-item-${category.id}-${i}`}>
                    {item.price != null ? `${item.price}` : "—"}
                </span>
            </li>
        ))}
    </ul>
);

export const MenuSection = () => (
    <section id="menu" className="bg-superficie py-20 md:py-28">
        <div className="container-pub">
            <Reveal>
                <SectionTitle eyebrow="Da bere e da mangiare" title="Menu" />
            </Reveal>
            <Reveal className="mt-8">
                <div className="flex flex-wrap items-center gap-2" data-testid="menu-highlights">
                    <span className="text-sm text-avorio/70 mr-1 inline-flex items-center gap-1.5">
                        <Star className="w-4 h-4 text-ambra" fill="currentColor" strokeWidth={0} /> I più apprezzati su
                        Google:
                    </span>
                    {menu.highlights.map((h) => (
                        <span key={h} className="chip !min-h-0 !py-2">
                            {h}
                        </span>
                    ))}
                </div>
            </Reveal>
            <Reveal className="hidden md:block mt-8">
                <Tabs defaultValue={menu.categories[0].id}>
                    <TabsList className="flex flex-wrap w-full h-auto bg-carbone border border-bordo rounded-xl p-1.5 justify-start gap-1">
                        {menu.categories.map((c) => (
                            <TabsTrigger
                                key={c.id}
                                value={c.id}
                                className="rounded-lg px-4 py-2.5 text-[15px] data-[state=active]:bg-ambra data-[state=active]:text-carbone data-[state=inactive]:text-avorio/70"
                                data-testid={`menu-tab-${c.id}`}
                            >
                                {c.name}
                            </TabsTrigger>
                        ))}
                    </TabsList>
                    {menu.categories.map((c) => (
                        <TabsContent key={c.id} value={c.id} className="mt-6" data-testid={`menu-panel-${c.id}`}>
                            <ItemList category={c} />
                        </TabsContent>
                    ))}
                </Tabs>
            </Reveal>
            <div className="md:hidden mt-8">
                <Accordion type="single" collapsible className="border border-bordo rounded-xl px-4 bg-carbone">
                    {menu.categories.map((c) => (
                        <AccordionItem key={c.id} value={c.id} className="border-bordo">
                            <AccordionTrigger className="text-[15.5px] hover:no-underline" data-testid={`menu-accordion-${c.id}`}>
                                {c.name}
                            </AccordionTrigger>
                            <AccordionContent>
                                <ItemList category={c} />
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
            <Reveal className="mt-10 max-w-2xl">
                <p className="text-sm text-avorio/60">{menu.note}</p>
            </Reveal>
        </div>
    </section>
);